(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pg-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pgRevealInit() {
    if (!window.pgRevealObserver) {
      window.pgRevealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); window.pgRevealObserver.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    document.querySelectorAll('.pg-reveal:not(.is-in)').forEach(function (el) { window.pgRevealObserver.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pgRevealInit); } else { pgRevealInit(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-bestsellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pgToast(msg) {
    var t = document.getElementById('pg-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'pg-toast';
      t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(16px);z-index:60;display:flex;align-items:center;gap:8px;background:#1A1A1A;color:#fff;border-radius:100px;padding:11px 18px;font-family:Barlow,sans-serif;font-size:13.5px;font-weight:600;box-shadow:0 10px 30px rgba(26,26,26,.3);opacity:0;transition:opacity .25s ease,transform .25s cubic-bezier(.23,1,.32,1);pointer-events:none;max-width:90vw;white-space:nowrap;';
      document.body.appendChild(t);
    }
    t.innerHTML = '<span style="display:inline-flex;width:18px;height:18px;border-radius:50%;background:#2F9469;color:#fff;align-items:center;justify-content:center;font-size:11px;flex-shrink:0;">✓</span>' + msg;
    clearTimeout(t._pgTimer);
    requestAnimationFrame(function () { t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(0)'; });
    t._pgTimer = setTimeout(function () { t.style.opacity = '0'; t.style.transform = 'translateX(-50%) translateY(16px)'; }, 2200);
  }
  function pgCartFetch(url, opts) {
    try {
      if (!window.__pgFrame || !window.__pgFrame.contentWindow) {
        var f = document.createElement('iframe');
        f.style.display = 'none';
        f.src = 'about:blank';
        document.body.appendChild(f);
        window.__pgFrame = f;
      }
      return window.__pgFrame.contentWindow.fetch(url, opts);
    } catch (e) { return fetch(url, opts); }
  }
  function pgSyncBadge() {
    var headSec = document.querySelector('[id^="shopify-section-"][id*="__header"]');
    var cur = document.querySelector('.header__cart-count');
    if (!headSec || !cur) return;
    var id = headSec.id.replace('shopify-section-', '');
    fetch(window.location.pathname + '?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[id];
        if (!html) return;
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        var fresh = tpl.content.querySelector('.header__cart-count');
        var target = document.querySelector('.header__cart-count');
        if (fresh && target) target.replaceWith(fresh);
      })
      .catch(function () {});
  }
  function pgBsInit() {
    document.querySelectorAll('.pg-bs').forEach(function (section) {
      if (section.dataset.pgBsReady) return;
      section.dataset.pgBsReady = '1';
      var track = section.querySelector('[data-track]');
      var arrows = section.querySelectorAll('.pg-bs__arrow');
      if (!track || !arrows.length) return;
      var step = function () {
        var card = track.querySelector('.pg-bs__card');
        return card ? (card.getBoundingClientRect().width + 16) * 2 : 600;
      };
      arrows.forEach(function (btn) {
        btn.addEventListener('click', function () {
          track.scrollBy({ left: step() * Number(btn.dataset.dir), behavior: 'smooth' });
        });
      });
      var sync = function () {
        arrows[0].toggleAttribute('disabled', track.scrollLeft <= 4);
        arrows[1].toggleAttribute('disabled', track.scrollLeft >= track.scrollWidth - track.clientWidth - 4);
      };
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
      var dotsWrap = section.querySelector('[data-dots]');
      var cards = track.querySelectorAll('.pg-bs__card');
      if (dotsWrap && cards.length) {
        var cardLeft = function (c) { return c.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft; };
        dotsWrap.innerHTML = '';
        cards.forEach(function (c, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.setAttribute('aria-label', 'Produit ' + (i + 1));
          d.addEventListener('click', function () {
            track.scrollTo({ left: cardLeft(c) - (track.clientWidth - c.clientWidth) / 2, behavior: 'smooth' });
          });
          dotsWrap.appendChild(d);
        });
        var dots = dotsWrap.querySelectorAll('button');
        var syncDots = function () {
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = 0, bd = Infinity;
          cards.forEach(function (c, i) {
            var dist = Math.abs(cardLeft(c) + c.clientWidth / 2 - mid);
            if (dist < bd) { bd = dist; best = i; }
          });
          dots.forEach(function (b, i) { b.classList.toggle('is-active', i === best); });
        };
        track.addEventListener('scroll', syncDots, { passive: true });
        syncDots();
      }
      section.querySelectorAll('[data-pg-add]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (btn.dataset.pgBusy) return;
          btn.dataset.pgBusy = '1';
          pgCartFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: Number(btn.dataset.pgAdd), quantity: 1 }) })
            .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
            .then(function () {
              btn.classList.add('is-added'); btn.textContent = '✓';
              pgSyncBadge();
              pgToast('Produit ajouté au panier avec succès');
              setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = '+'; delete btn.dataset.pgBusy; }, 1800);
            })
            .catch(function () {
              delete btn.dataset.pgBusy;
              var a = btn.closest('a');
              if (a) window.location.href = a.href;
            });
        });
      });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pgBsInit); } else { pgBsInit(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-insta"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pgRevealInit() {
    if (!window.pgRevealObserver) {
      window.pgRevealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); window.pgRevealObserver.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    document.querySelectorAll('.pg-reveal:not(.is-in)').forEach(function (el) { window.pgRevealObserver.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pgRevealInit); } else { pgRevealInit(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-newsletter"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pgRevealInit() {
    if (!window.pgRevealObserver) {
      window.pgRevealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); window.pgRevealObserver.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    document.querySelectorAll('.pg-reveal:not(.is-in)').forEach(function (el) { window.pgRevealObserver.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pgRevealInit); } else { pgRevealInit(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pgRevealInit() {
    if (!window.pgRevealObserver) {
      window.pgRevealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); window.pgRevealObserver.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    document.querySelectorAll('.pg-reveal:not(.is-in)').forEach(function (el) { window.pgRevealObserver.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pgRevealInit); } else { pgRevealInit(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-values"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pgRevealInit() {
    if (!window.pgRevealObserver) {
      window.pgRevealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); window.pgRevealObserver.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    document.querySelectorAll('.pg-reveal:not(.is-in)').forEach(function (el) { window.pgRevealObserver.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pgRevealInit); } else { pgRevealInit(); }
})();

  } catch(e) { console.error(e); }
})();
})();
